import { updateOrganization } from '@usehatchapp/javascript-sdk';

import { constants } from '../constants';

export const doUpdateOrganization =
  ({ data, organizationId }) =>
  async ({ dispatch, request }) => {
    const {
      UPDATE_ORGANIZATION_FAILURE,
      UPDATE_ORGANIZATION_REQUEST,
      UPDATE_ORGANIZATION_SUCCESS,
    } = constants;

    try {
      // Spot check required form data exists
      const { businessHours, afterHours, ...organization } = data;
      if (!businessHours || !afterHours)
        return dispatch({
          error: new Error(`invalid form data`),
          type: UPDATE_ORGANIZATION_FAILURE,
        });

      dispatch({ type: UPDATE_ORGANIZATION_REQUEST });

      // Attempt to update organization
      await request(updateOrganization, {
        data: {
          afterHours,
          businessHours,
          ...organization,
        },
        organizationId,
      });

      // Read the new organizations details and add it to store
      dispatch({
        actionCreator: 'doReadOrganization',
        args: [{ organizationIDs: [organizationId] }],
      });
      dispatch({
        actionCreator: 'doCreateNotificationMessage',
        args: [
          { message: `Successfully updated account details!`, type: 'success' },
        ],
      });

      return dispatch({ type: UPDATE_ORGANIZATION_SUCCESS });
    } catch (error) {
      return dispatch({ error, type: UPDATE_ORGANIZATION_FAILURE });
    }
  };
